<template>
    <div class="item-hours">
        <span class="country">{{time.format('z')}}</span>
        <span class="hour">{{time.format('HH:mm')}}</span>
    </div>
</template>

<script>
    let moment = require('moment-timezone');

    export default {
        props: {
            timezone: {
                default: 'Pacific/Auckland'
            }
        },
        mounted(){
            setInterval(()=>{
                this.time = this.getTime()
            }, 1000);
        },
        data(){
            return {
                tz_map: {
                    'Asia/Tokyo': 'JPN',
                    'Pacific/Auckland': 'NZ'
                },
                time : this.getTime()
            }
        },
        methods : {
            getTime(){
                let now = moment().tz(this.timezone);
                return now;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/HeaderTime.vue